import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  token,
  alert,
  float,
  required,
  params,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import LOGO from "../assets/images/logo.png";
import LOGO512 from "../assets/images/logo512.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      company: "",
      title: "",
      message: "",
    };
  }
  async componentDidMount() {
    loading(false);
    if (params("subject")) {
      const target = document.getElementById("input-message");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      if (params("subject")?.includes("package")) {
        this.setState({
          title: `สอบถามแพ็คเกจ "${params("subject")?.split(":")[1]}"`,
          message: `สนใจแพ็คเกจ "${
            params("subject")?.split(":")[1]
          }" ต้องการสอบถามรายละเอียดเพิ่มเติมเกี่ยวกับแพ็คเกจนี้ 
- ฟีเจอร์หลักและตัวเลือกเสริม
- ราคาและโปรโมชั่น
- ระยะเวลาให้บริการ
- เงื่อนไขการชำระเงินและการติดตั้ง
กรุณาติดต่อกลับเมื่อสะดวก ขอบคุณครับ/ค่ะ`,
        });
      }else if (params("subject")?.includes("นัดหมายปรึกษา")) {
        this.setState({
          title: `นัดหมายปรึกษา`,
          message: `ต้องการนัดหมายเพื่อปรึกษาเกี่ยวกับโซลูชันเทคโนโลยีสำหรับธุรกิจของเรา 
- วันที่และเวลาที่สะดวก
- ช่องทางการติดต่อ (เช่น โทรศัพท์, วิดีโอคอล ฯลฯ)
- หัวข้อหรือประเด็นที่ต้องการปรึกษา
กรุณาติดต่อกลับเพื่อยืนยันการนัดหมาย ขอบคุณครับ/ค่ะ`,
        });
      } else if (params("subject")?.includes("ขอใบเสนอราคา")) {
        this.setState({
          title: `ขอใบเสนอราคา `,
          message: `สนใจบริการ/โซลูชัน
ต้องการขอใบเสนอราคาสำหรับบริการนี้ 
- รายละเอียดหรือความต้องการเฉพาะ
- ระยะเวลาที่ต้องการเริ่มต้นและสิ้นสุด
- งบประมาณโดยประมาณ (ถ้ามี)
กรุณาติดต่อกลับพร้อมใบเสนอราคา ขอบคุณครับ/ค่ะ`,
        });
      } else if (params("subject")?.includes("ปรึกษาแพ็คเกจที่เหมาะสม")) {
        this.setState({
          title: `ปรึกษาแพ็คเกจที่เหมาะสม`,
          message: `ต้องการคำแนะนำเพื่อเลือกแพ็คเกจบริการพัฒนาซอฟต์แวร์ที่เหมาะสมกับความต้องการของธุรกิจเรา 
- ประเภทของธุรกิจและขนาดองค์กร
- เป้าหมายและความต้องการหลัก
- งบประมาณโดยประมาณ
- ระยะเวลาที่คาดหวังในการดำเนินโครงการ
กรุณาติดต่อกลับเพื่อให้คำแนะนำ ขอบคุณครับ/ค่ะ`,
        });
      } else if (params("subject")?.includes("เริ่มต้นโครงการใหม่")) {
        this.setState({
          title: `เริ่มต้นโครงการใหม่`,
          message: `ต้องการเริ่มต้นโครงการพัฒนาซอฟต์แวร์ใหม่กับทางบริษัท 
- ประเภทของซอฟต์แวร์ที่ต้องการ (เว็บไซต์, แอปพลิเคชัน, ระบบ IoT ฯลฯ)
- ฟีเจอร์หลักและฟังก์ชันที่ต้องการ
- กำหนดเวลาที่คาดหวังในการดำเนินโครงการ
- งบประมาณโดยประมาณ
กรุณาติดต่อกลับเพื่อหารือรายละเอียด ขอบคุณครับ/ค่ะ`,
        });
      }
    }
  }
  Submit = async () => {
    const { first_name, last_name, email, phone, company, title, message } =
      this.state;
    if (!first_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ");
      return;
    }
    if (!last_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกนามสกุล");
      return;
    }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }
    if (!email.includes("@")) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }
    if (phone.length < 10) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ครบถ้วน");
      return;
    }
    if (!float(phone)) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ถูกต้อง");
      return;
    }
    if (!title) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกหัวข้อ");
      return;
    }
    if (!message) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกข้อความ");
      return;
    }
    loading(true);

    await fetch(
      `https://zanithit-958b8-default-rtdb.asia-southeast1.firebasedatabase.app/contact/${phone}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          date: new Date().toLocaleString("th-TH", {
            timeZone: "Asia/Bangkok",
          }),
          first_name: first_name,
          last_name: last_name,
          email: email,
          phone: phone,
          company: company,
          title: title,
          message: message,
        }),
      }
    );
    loading(false);
    alert(
      "#",
      "success",
      "สำเร็จ",
      "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด"
    );
  };
  render() {
    const { first_name, last_name, email, phone, company, title, message } =
      this.state;
    return (
      <div className="w-100 min-vh-100 background position-relative">
        <Navbar />
        {/* SECTION 1 */}
        <div className="w-100 bg-blue text-white align-content-center">
          <div className="container mx-auto px-4 text-center py-5">
            <div className="my-5">
              <h1 className="fw-bold mb-4">ติดต่อเรา</h1>
              <h5 className="mb-3">พร้อมให้คำปรึกษาและเริ่มต้นโครงการของคุณ</h5>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 align-content-center bg-gray">
          <div className="row mx-0">
            <div className="col-12 col-md-6 mb-3">
              <div className="p-5 pb-">
                <div className="mb-2">มาทำงานร่วมกัน</div>
                <h2 className="fw-bold">ติดต่อทีมสนับสนุนและฝ่ายขายของเรา</h2>
                <div className="mb-5">
                  เรายินดีรับฟังความต้องการของคุณและให้คำปรึกษาเกี่ยวกับโซลูชันเทคโนโลยี
                  ที่เหมาะสมกับธุรกิจของคุณ
                </div>
                <div className="d-flex mb-4">
                  <div className="wpx-40 hpx-40 bg-primary-light rounded-3 d-flex align-items-center justify-content-center">
                    <h5 className="icon">{"\uf0e0"}</h5>
                  </div>
                  <div className="ps-3">
                    <b>อีเมล</b>
                    <br />
                    <a
                      className="text-secondary text-decoration-none"
                      href={`mailto:${global.email}`}
                    >
                      {global.email}
                    </a>
                  </div>
                </div>
                <div className="d-flex mb-4">
                  <div className="wpx-40 hpx-40 bg-primary-light rounded-3 d-flex align-items-center justify-content-center">
                    <h5 className="icon">{"\uf017"}</h5>
                  </div>
                  <div className="ps-3">
                    <b>เวลาทำการ</b>
                    <br />
                    <span className="text-secondary">
                      จันทร์ - ศุกร์: 9:00 - 18:00
                    </span>
                    <br />
                    <span className="text-secondary">เสาร์: 9:00 - 16:00</span>
                    <br />
                    <span className="text-secondary">อาทิตย์: ปิดทำการ</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 py-5" id="input-message">
              <div className="card card-dashboard rounded-3 bg-white p-4 border-1">
                <h4 className="fw-bold mb-4">
                  ส่งข้อความถึงเรา
                  <img
                    alt="LOGO"
                    src={LOGO}
                    className="wpx-150 ms-2"
                    style={{ objectFit: "contain" }}
                  />
                </h4>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <label className="mb-1">ชื่อ {required}</label>
                    <input
                      className="form-control mb-3"
                      type="text"
                      placeholder="กรอกชื่อของคุณ"
                      onChange={(e) => {
                        this.setState({ first_name: e.target.value });
                      }}
                      value={first_name}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="mb-1">นามสกุล {required}</label>
                    <input
                      className="form-control mb-3"
                      type="text"
                      placeholder="กรอกนามสกุลของคุณ"
                      onChange={(e) => {
                        this.setState({ last_name: e.target.value });
                      }}
                      value={last_name}
                    />
                  </div>
                  <div className="col-12">
                    <label className="mb-1">อีเมล {required}</label>
                    <input
                      className="form-control mb-3"
                      type="email"
                      placeholder="example@company.com"
                      onChange={(e) => {
                        this.setState({ email: e.target.value });
                      }}
                      value={email}
                    />
                  </div>
                  <div className="col-12">
                    <label className="mb-1">
                      เบอร์โทรศัพท์ (สำหรับติดต่อกลับ) {required}
                    </label>
                    <input
                      className="form-control mb-3"
                      type="text"
                      placeholder="08XXXXXXXX"
                      maxLength={10}
                      onChange={(e) => {
                        if (!float(e.target.value)) {
                          return;
                        }
                        this.setState({ phone: e.target.value });
                      }}
                      value={phone}
                    />
                  </div>
                  <div className="col-12">
                    <label className="mb-1">บริษัท/องค์กร</label>
                    <input
                      className="form-control mb-3"
                      type="text"
                      placeholder="ชื่อบริษัทหรือองค์กรของคุณ"
                      onChange={(e) => {
                        this.setState({ company: e.target.value });
                      }}
                      value={company}
                    />
                  </div>
                  <div className="col-12">
                    <label className="mb-1">หัวข้อ {required}</label>
                    <input
                      className="form-control mb-3"
                      type="text"
                      placeholder="เรื่องที่ต้องการติดต่อ"
                      onChange={(e) => {
                        this.setState({ title: e.target.value });
                      }}
                      value={title}
                    />
                  </div>
                  <div className="col-12">
                    <label className="mb-1">ข้อความ {required}</label>
                    <textarea
                      className="form-control mb-3"
                      rows={8}
                      placeholder="รายละเอียดโครงการหรือสิ่งที่ต้องการปรึกษา"
                      onChange={(e) => {
                        this.setState({ message: e.target.value });
                      }}
                      value={message}
                    />
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary px-5"
                      onClick={async () => {
                        this.Submit();
                      }}
                    >
                      ส่งข้อความ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
